import { GetCurrentPatients_getCurrentPatients_patients } from "@/components/graphql/types/getCurrentPatient";
import { Gender } from "@/components/graphql/types/globalTypes";
import { isBrowser } from "@/libs/helpers";
import { NEXT_PUBLIC_CDN_URL } from "@/libs/constants/auth";

declare global {
  interface Window {
    clevertap: any;
    Juspay: any;
  }
}

if (isBrowser()) {
  window.clevertap = window.clevertap || {};
}

export const clevertapGetProfileAttribute = (attributeName: string) => {
  if (typeof window !== "undefined" && isBrowser()) {
    try {
      return window.clevertap.profile.getAttribute(attributeName);
    } catch (err) {
      console.error("Clevertap user profile push tracking err: ", err);
    }
  }
};

export const clevertapPushProfileUpdates = (
  userData: GetCurrentPatients_getCurrentPatients_patients,
  data: any = undefined
) => {
  if (typeof window !== "undefined" && isBrowser()) {
    try {
      window.clevertap.profile.push({
        Site: {
          Name: userData.firstName + " " + (userData.lastName || ""),
          UHID: userData.uhid || "",
          "MSG-whatsapp": data?.whatsappOptIn,
          Identity: userData.mobileNumber.slice(3) || "",
          MobileNumber: userData.mobileNumber || "",
          Phone: userData.mobileNumber || "",
          Firstname: userData.firstName || "",
          ...(userData.lastName && { Lastname: userData.lastName }),
          Relation: userData.relation || "",
          Gender: userData.gender == Gender.MALE ? "M" : userData.gender == Gender.FEMALE ? "F" : "",
          DOB: new Date(userData.dateOfBirth),
          ...(userData.emailAddress && { Email: userData.emailAddress }),
          ...(userData.photoUrl && { Photo: userData.photoUrl }),
          ...(userData.createdDate && { CreatedDate: userData.createdDate }),
        },
      });
    } catch (err) {
      console.error("Clevertap user profile push tracking err: ", err);
    }
  }
};

export const clevertapPushNotification = () => {
  if (typeof window !== "undefined") {
    try {
      window.clevertap.notifications.push({
        titleText: `<img src="${NEXT_PUBLIC_CDN_URL}/images/honk_01.gif" />`,
        bodyText:
          "<h3> Never miss the latest updates and offers!</h3> <p>Get instant notifications from Apollo Pharmacy</p>",
        okButtonText: "Yes, I'm on Board",
        rejectButtonText: "Later",
        okButtonColor: "#fff",
        serviceWorkerPath: "/service-worker.js",
      });
    } catch (err) {
      console.error("Clevertap user login tracking err: ", err);
    }
  }
};

export const clevertapUserLoginTracking = (
  userData: GetCurrentPatients_getCurrentPatients_patients,
  data: any = undefined
) => {
  if (typeof window !== "undefined" && isBrowser()) {
    try {
      window.clevertap.onUserLogin.push({
        Site: {
          Name: userData.firstName + " " + (userData.lastName || ""),
          UHID: userData.uhid || "",
          "MSG-whatsapp": data?.whatsappOptIn,
          Identity: userData.mobileNumber.slice(3) || "",
          MobileNumber: userData.mobileNumber || "",
          Phone: userData.mobileNumber || "",
          Firstname: userData.firstName || "",
          ...(userData.lastName && { Lastname: userData.lastName }),
          Relation: userData.relation || "",
          Gender: userData.gender == Gender.MALE ? "M" : userData.gender == Gender.FEMALE ? "F" : "",
          DOB: new Date(userData.dateOfBirth),
          ...(userData.emailAddress && { Email: userData.emailAddress }),
          ...(userData.photoUrl && { Photo: userData.photoUrl }),
          ...(userData.createdDate && { CreatedDate: userData.createdDate }),
        },
      });
    } catch (err) {
      console.error("Clevertap user login tracking err: ", err);
    }
  }
};

export const clevertapSetIndentity = (number: string) => {
  if (typeof window !== "undefined" && isBrowser()) {
    try {
      window.clevertap.onUserLogin.push({
        Site: {
          Identity: number?.slice(3) || "",
        },
      });
    } catch (err) {
      console.error("Clevertap user login tracking err: ", err);
    }
  }
};

export const clevertapUserLogoutTracking = () => {
  if (typeof window !== "undefined" && isBrowser()) {
    try {
      window.clevertap.logout();
    } catch (err) {
      console.error("Clevertap user login tracking err: ", err);
    }
  }
};

export function eventTracking(eventName: string, data: any = undefined) {
  Promise.all([clevertapTracking(eventName, data)]);
}

const getCTEventLoggedDateTimestamp = (): string => {
  return `$D_${new Date().getTime()}`;
};

const linearisedObject = (data: object): object => {
  // convert all the values of each key into string
  Object.keys(data).forEach((key) => {
    if (typeof data[key] == "object") {
      data[key] = JSON.stringify(data[key]);
    }
  });

  return data;
};

export const clevertapTracking = (eventName: string, data: any = undefined) => {
  try {
    if (typeof window !== "undefined" && window?.clevertap?.event) {
      if (data) {
        if (typeof data == "object") {
          data = linearisedObject(data);
          data["ts"] = getCTEventLoggedDateTimestamp();
        }

        window.clevertap.event.push(eventName, { ...data, lob: "momverse", page_url: window.location.href });
      } else {
        window.clevertap.event.push(eventName);
      }
    }
  } catch (err) {
    console.error("Clevertap Err: ", err);
  }
};

export default clevertapTracking;
